export default {
  'SAVE_USER' (state, payload) {
    payload = Object.assign({}, state.user, payload)
    state.user = payload
    window.localStorage.setItem('user', JSON.stringify(state.user))
  },
  'UNSET_USER' (state) {
    state.user = false
    window.localStorage.removeItem('user')
  },
  'SAVE_CITY' (state, payload) {
    state.city = payload
    window.localStorage.setItem('city', JSON.stringify(state.city))
  },
  'UNSET_CITY' (state) {
    state.city = false
    window.localStorage.removeItem('city')
  },
  'SAVE_MKTP_RENT' (state, payload) {
    payload = Object.assign({}, state.mktp_rent, payload)
    state.mktp_rent = payload
    window.localStorage.setItem('mktp_rent', JSON.stringify(state.mktp_rent))
  },
  'UNSET_MKTP_RENT' (state) {
    state.mktp_rent = false
    window.localStorage.removeItem('mktp_rent')
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js